import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import * as classnames from 'classnames';
import { styled } from '@mui/material';
import Clear from 'console/images/pin-dialog/clear.svg';
import { useBooleanState } from 'shared/hooks/state/boolean';
const StyledCircle = styled('span')(({ theme }) => ({
    boxSizing: 'border-box',
    display: 'inline-block',
    width: '18px',
    height: '18px',
    border: '2px solid #666',
    borderRadius: '100%',
    borderColor: theme.palette.mode === 'dark' ? '#ccc' : '#666',
    '&.filled': {
        borderColor: theme.palette.mode === 'dark' ? '#eee' : '#444',
        background: theme.palette.mode === 'dark' ? '#eee' : '#444',
    },
}));
export const Circle = ({ filled }) => {
    return (_jsx("div", { children: _jsx(StyledCircle, { className: classnames('', { filled }) }) }));
};
const StyledPinButton = styled('div')({
    width: '64px',
    height: '64px',
    margin: '10px',
    'div: first-of-type': {
        marginLeft: 0,
    },
    '&:last-child': {
        marginRight: 0,
    },
    borderRadius: '100%',
    border: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    WebkitTouchCallout: 'none',
    WebkitTapHighlightColor: 'transparent',
    '& .forgot': {
        fontSize: '14px',
        textAlign: 'center',
    },
    '&.pressed': {
        background: '#ccc',
    },
});
const StyledRow = styled('div')({
    display: 'flex',
    flexFlow: 'row nowrap',
    fontSize: '36px',
    fontWeight: 100,
});
export function RoundButton({ onClick, onRelease, children, }) {
    const [pressed, noPressed, setPressed] = useBooleanState(false);
    const on_pressed = useCallback((event) => {
        event.preventDefault();
        setPressed();
        onClick?.();
    }, [setPressed, onClick]);
    const on_released = useCallback((event) => {
        event.preventDefault();
        noPressed();
        onRelease?.();
    }, [noPressed, onRelease]);
    return (_jsx(StyledPinButton, { className: classnames('', { pressed }), onTouchStart: on_pressed, onMouseDown: on_pressed, onTouchEnd: on_released, onMouseUp: on_released, children: children }));
}
export const DigitButton = ({ digit, onClick, onRelease, }) => (_jsx(RoundButton, { onClick: () => onClick(digit), onRelease: onRelease, children: digit }));
export const KeyPad = ({ cornerButton, onDigit, onRelease, onClear, }) => {
    return (_jsxs("div", { children: [_jsxs(StyledRow, { children: [_jsx(DigitButton, { digit: 1, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 2, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 3, onClick: onDigit, onRelease: onRelease })] }), _jsxs(StyledRow, { children: [_jsx(DigitButton, { digit: 4, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 5, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 6, onClick: onDigit, onRelease: onRelease })] }), _jsxs(StyledRow, { children: [_jsx(DigitButton, { digit: 7, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 8, onClick: onDigit, onRelease: onRelease }), _jsx(DigitButton, { digit: 9, onClick: onDigit, onRelease: onRelease })] }), _jsxs(StyledRow, { children: [_jsx(RoundButton, { onClick: onClear, children: _jsx(Clear, {}) }), _jsx(DigitButton, { digit: 0, onClick: onDigit, onRelease: onRelease }), cornerButton] })] }));
};
